import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bffe2292&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=bffe2292&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bffe2292",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\mam\\home\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bffe2292')) {
      api.createRecord('bffe2292', component.options)
    } else {
      api.reload('bffe2292', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=bffe2292&scoped=true", function () {
      api.rerender('bffe2292', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/contactUs/index.vue"
export default component.exports